<template>
	<div class="error-page">
		<h1>{{ errorMessage }}</h1>
		<p>
			{{
				$route.meta.title === 403
					? "К сожалению, запрошенная вами страница не доступна, обратитесь к Администратору или проверьте разрешение на навигацию"
					: $route.meta.title === 404
						? "К сожалению, запрошенная вами страница не существует"
						: "К сожалению, запрошенная вами страница не может быть отображенна"
			}}
		</p>
	</div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const errorMessage = computed(() => (route.meta.title ? `Ошибка ${route.meta.title}` : "Ошибка"));
</script>

<style lang="scss">
.error-page {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 100vh;
	min-width: 100vw;
	text-align: center;
}

.error-page h1 {
	font-size: 2rem;
	color: #f44336;
}

.error-page p {
	font-size: 1.2rem;
}

.error-page a:hover {
	text-decoration: underline;
}
</style>
